import { styled } from '@mui/material';

export const classes = {
  logo: 'logo',
};

const CMPSidebar = styled('nav')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'fixed',
  left: 0,
  bottom: 0,
  right: 0,
  width: '100%',
  height: 76,
  zIndex: 1000,
  background: 'linear-gradient(93deg, rgba(2,0,36,1) 0%, rgba(20,0,52,1) 40%)',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'column',
    top: 0,
    left: 0,
    bottom: 0,
    width: 84,
    height: '100%',
    background: 'linear-gradient(187deg, rgba(2,0,36,1) 0%, rgba(20,0,52,1) 40%)',
  },
  [`& .${classes.logo}`]: {
    position: 'absolute',
    top: 16,
  },
}));
export default CMPSidebar;
